import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import type { AccountViewResponseDTO } from '../types';

// Deterministic initials for the avatar fallback (displayName -> up to 2 letters, else email).
function initials(admin: AccountViewResponseDTO): string {
  const source = admin.displayName?.trim() || admin.email?.trim() || '?';
  const parts = source.split(/\s+/).filter(Boolean);
  const letters =
    parts.length >= 2 ? `${parts[0]?.[0] ?? ''}${parts[1]?.[0] ?? ''}` : source.slice(0, 2);
  return letters.toUpperCase();
}

export function AdminNameCell({ admin }: { admin: AccountViewResponseDTO }) {
  return (
    <div className="flex items-center gap-3">
      <Avatar className="h-8 w-8">
        <AvatarFallback className="text-xs">{initials(admin)}</AvatarFallback>
      </Avatar>
      <div className="min-w-0">
        <div className="truncate font-medium">{admin.displayName || '—'}</div>
        <div className="truncate text-xs text-muted-foreground">{admin.email}</div>
      </div>
    </div>
  );
}
